import { useLayoutEffect, useRef } from "react";

/** Five visible lines, growing to ten before the textarea itself scrolls. */
export function DocumentDescription({ id, value, onChange }: { id?: string; value: string; onChange: (value: string) => void }) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const resize = () => {
      const input = ref.current;
      if (!input) return;
      input.style.height = "auto";
      input.style.height = `${Math.max(114, Math.min(214, input.scrollHeight + 2))}px`;
      input.style.overflowY = input.scrollHeight + 2 > 214 ? "auto" : "hidden";
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [value]);
  return <textarea ref={ref} id={id} aria-label="Opis" rows={5} value={value} onChange={(event) => onChange(event.target.value)}
    className="w-full resize-none rounded-md border border-slate-400 bg-slate-100 px-2 py-1.5 text-sm focus-visible:outline-2 focus-visible:outline-blue-500"
    style={{ lineHeight: "20px", minHeight: "114px", maxHeight: "214px" }} />;
}
